namespace RedBullMOBILE360.Utilities {
    export interface ReAuthenticateNumbersForm {
        Msisdn: Serenity.StringEditor;
        IdNumber: Serenity.StringEditor;
        IdType: Serenity.IntegerEditor;
        Nationality: Serenity.IntegerEditor;
        TccRequest: Serenity.StringEditor;
        TccResponse: Serenity.StringEditor;
        BssRequest: Serenity.StringEditor;
        BssResponse: Serenity.StringEditor;
        OperationType: Serenity.StringEditor;
        Status: Serenity.StringEditor;
        TccIdNumber: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
        FirstName: Serenity.StringEditor;
        LastName: Serenity.StringEditor;
        Iccid: Serenity.StringEditor;
        IamOtp: Serenity.StringEditor;
        IsMnp: Serenity.IntegerEditor;
        PrepostPaid: Serenity.IntegerEditor;
        IsEsim: Serenity.IntegerEditor;
    }

    export class ReAuthenticateNumbersForm extends Serenity.PrefixedContext {
        static formKey = 'Utilities.ReAuthenticateNumbers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReAuthenticateNumbersForm.init)  {
                ReAuthenticateNumbersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(ReAuthenticateNumbersForm, [
                    'Msisdn', w0,
                    'IdNumber', w0,
                    'IdType', w1,
                    'Nationality', w1,
                    'TccRequest', w0,
                    'TccResponse', w0,
                    'BssRequest', w0,
                    'BssResponse', w0,
                    'OperationType', w0,
                    'Status', w0,
                    'TccIdNumber', w0,
                    'CreationDate', w2,
                    'FirstName', w0,
                    'LastName', w0,
                    'Iccid', w0,
                    'IamOtp', w0,
                    'IsMnp', w1,
                    'PrepostPaid', w1,
                    'IsEsim', w1
                ]);
            }
        }
    }
}
